import Config from "../config";
import { AxiosInstance } from "../helpers/AxiosInstance";
import { UtilityService } from "./UtilityService";


const sendPaymentDueNotification = (to: { Email: string, CustomerName: string }[], details: { PhoneNumber: string, PlanName: string, Amount: string, RenewalDate: string, RenewalAmount: string, PaymentLink: string }) => {
    const data = {
        templateId: "d-4c3148074c6d42268b139be7c1a83c62",
        data: to.map(x => { return { email: x.Email, data: [{ name: "CustomerName", value: x.CustomerName }] } }),
        commonData: [...Object.keys(details).map(key => { return { name: key, value: (details as any)[key] } }), {
            name: "Subject",
            value: `Your payment is due for ${details.PhoneNumber}`
        }]
    }
    return AxiosInstance.post(`${Config.API_URL}/api/Settings/SendNotification`, data)
}

const sendVoipEmailNotificationtoSupport = (to: { Email: string, Name: string }[], details: { ProductName: string, FirstName: string, LastName: string, Email: string, MobileNumber: string, Organization: string, Industry: string, HouseNumber: string, StreetName: string, Zipcode: string, City: string, State: string, Country: string, Name: string, PhoneNumber: string }) => {
    const data = {
        templateId: "d-69c2ea1f1d084941a773a7c54a59af0c",
        data: to.map(x => { return { email: x.Email, data: [{ name: x.Name, value: x.Name }] } }),
        commonData: [...Object.keys(details).map(key => { return { name: key, value: (details as any)[key] } }), {
            name: "Subject",
            value: ` New Number | ${details.ProductName}`
        }]
    }
    return AxiosInstance.post(`${Config.API_URL}/api/Settings/SendNotification`, data)
}

const sendVoipEmailNotificationtoUser = (to: { Email: string, Name: string }[], details: { FirstName: string }) => {
    const data = {
        templateId: "d-dcb0dcbafeed4710bb668924026de051",
        data: to.map(x => { return { email: x.Email, data: [{ name: x.Name, value: x.Name }] } }),
        commonData: [...Object.keys(details).map(key => { return { name: key, value: (details as any)[key] } }), {
            name: "Subject",
            value: "Thank you for choosing Falkon SMS"
        }]
    }
    return AxiosInstance.post(`${Config.API_URL}/api/Settings/SendNotification`, data)
}

const sendBugReportToSupport = (to: { Email: string, Name: string }[], details: { CustomerEmail: string, IssueType: string, CategoryType: string, Title: string, Description: string, FirstName: string, LastName: string, PhoneNumber: string, Organization: string, }) => {
    const data = {
        templateId: "d-1d3d35fdb55549e9afeccf954522e53a",
        data: to.map(x => { return { email: x.Email, data: [{ name: x.Name, value: x.Name }] } }),
        commonData: [...Object.keys(details).map(key => { return { name: key, value: (details as any)[key] } }), {
            name: "Subject",
            value: `Feedback - ${details.Title} `
        }]
    }
    return AxiosInstance.post(`${Config.API_URL}/api/Settings/SendNotification`, data)
}

const sendBugReportAckToUser = (to: { Email: string }[]) => {
    const data = {
        templateId: "d-06063ee3828c449696dbe7804d40f41c",
        data: to.map(x => { return { email: x.Email } }),
        commonData: [{
            name: "Subject",
            value: "Falkon SMS – Your feedback has been submitted"
        }]
    }
    return AxiosInstance.post(`${Config.API_URL}/api/Settings/SendNotification`, data)
}

const userRegistrationFailedtoSupport = (to: { Email: string, Name: string }[], details: { FirstName: string, LastName: string, Email: string, MobileNumber: string, Organization: string, Industry: string, HouseNumber: string, StreetName: string, ZipCode: string, City: string, State: string, Country: string }) => {
    const data = {
        templateId: "d-155420b685874853b7a3f045bd7dcafd",
        data: to.map(x => { return { email: x.Email, data: [{ name: x.Name, value: x.Name }] } }),
        commonData: [...Object.keys(details).map(key => { return { name: key, value: (details as any)[key] } }), {
            name: "Subject",
            value: `A user has left in the middle of registration`
        }]
    }
    return AxiosInstance.post(`${Config.API_URL}/api/Settings/SendNotification`, data)
}

const sendEmailToTechTeamSupport = (to: { Email: string }[], details: { ModuleName: string, Error: any }) => {
    const data = {
        templateId: "d-2ff8401873e447eb96411908dec6a79d",
        data: to.map(x => { return { email: x.Email } }),
        commonData: [...Object.keys(details).map(key => { return { name: key, value: (details as any)[key] } }), {
            name: "Subject",
            value: `${details.ModuleName}`
        }]
    }
    return AxiosInstance.post(`${Config.API_URL}/api/Settings/SendNotification`, data)
}

const userRegistrationDetailsToSupport = (to: { Email: string, Name: string }[], details: { FirstName: string, LastName: string, Email: string, MobileNumber: string, Organization: string }) => {
    const data = {
        templateId: "d-53ceb6c2251a4ada8e267510e4d1dfdb",
        data: to.map(x => { return { email: x.Email, data: [{ name: x.Name, value: x.Name }] } }),
        commonData: [...Object.keys(details).map(key => { return { name: key, value: (details as any)[key] } }), {
            name: "Subject",
            value: `A user has submitted the details in SignUp`
        }]
    }
    return AxiosInstance.post(`${Config.API_URL}/api/Settings/SendNotification`, data)
}

const sendEmailToIssueReportTeam = (to: { Email: string }[], details: { ModuleName: string, Error: any }) => {
    const data = {
        templateId: "d-2ff8401873e447eb96411908dec6a79d",
        data: to.map(x => { return { email: x.Email } }),
        commonData: [...Object.keys(details).map(key => { return { name: key, value: (details as any)[key] } }), {
            name: "Subject",
            value: `${details.ModuleName}`
        }]
    }
    return AxiosInstance.post(`${Config.API_URL}/api/Settings/SendNotification`, data)
}

export const EmailService = {
    sendPaymentDueNotification,
    sendBugReportToSupport,
    sendBugReportAckToUser,
    sendVoipEmailNotificationtoSupport,
    sendVoipEmailNotificationtoUser,
    userRegistrationFailedtoSupport,
    sendEmailToTechTeamSupport,
    sendEmailToIssueReportTeam,
    userRegistrationDetailsToSupport
};